export default "__VITE_ASSET__DSA33Ql8__"